import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

//Redux

import { useSelector } from 'react-redux';
import { RootState } from '../../store/configureStore';

//Material UI
// import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import SettingsIcon from '@material-ui/icons/Settings';
import IconButton from '@material-ui/core/IconButton';

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     button: {
//       '& > *': {
//         margin: theme.spacing(0, 0, 0, 1),
//       },
//     },
//   })
// );

export default function SettingsButtonAndMenuComponent() {
  // const classes = useStyles();
  const orgId: string = useSelector(
    (state: RootState) => state.organization.orgId
  );

  return (
    <IconButton
      edge="end"
      aria-label="account of current user"
      color="inherit"
      aria-controls="simple-menu"
      aria-haspopup="true"
      component={RouterLink}
      to={`/organizationId/${orgId}/settings`}
      // onClick={handleClick}
    >
      <SettingsIcon />
    </IconButton>
  );
}
